module.exports = __webpack_public_path__ + "static/weAreClevers-c0458b44bc498b1afa2521a5e6776fee.jpg";